import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Button, CircularProgress, Alert, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useGetImpactByIdQuery } from "./api/impactsApi";
import ImpactDetail from "./components/ImpactDetail";

const ImpactDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data: impact, isLoading, isError } = useGetImpactByIdQuery(id || "");

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isError || !impact?.data) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          Failed to load impact details. Please try again.
        </Alert>
        <Button
          variant="contained"
          startIcon={<ArrowBack />}
          onClick={() => navigate('/impacts')}
          sx={{ mt: 2 }}
        >
          Back to Impacts
        </Button>
      </Box>
    );
  }

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Button
          variant="outlined"
          startIcon={<ArrowBack />}
          onClick={() => navigate('/impacts')}
        >
          Back to Impacts
        </Button>
      </Box>
      
      <ImpactDetail impact={impact.data} />
    </Box>
  );
};

export default ImpactDetailPage;

